<template>
  <div class="home">
    <!-- <Navbar /> -->
    <vue-headful title="CHECK PHONE" />

    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>

      <a-row>
        <a-col :xs="0" :sm="4" :md="5" :lg="6"></a-col>

        <a-col :xs="24" :sm="16" :md="14" :lg="12">
          <fish-card fluid>
            <div slot="header">KIỂM TRA KHÁCH HÀNG</div>

            <a-form style="width: 100%" :form="form" @submit="handleSubmit">
              <a-form-item
                :validate-status="PhoneError() ? 'error' : ''"
                :help="PhoneError() || ''"
              >
                <a-input
                  autocomplete="off"
                  v-decorator="[
                    'Phone',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Vui lòng nhập số điện thoại cần kiểm tra!',
                        },
                        {
                          len: 10,
                          message: 'Vui lòng nhập SĐT 10 ký tự',
                        },
                      ],
                    },
                  ]"
                  placeholder="Nhập số điện thoại cần kiểm tra"
                >
                  <a-icon
                    slot="prefix"
                    type="phone"
                    style="color: rgba(0, 0, 0, 0.25)"
                  />
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :disabled="hasErrors(form.getFieldsError())"
                >
                  <a-icon type="search" />
                  CHECK
                </a-button>
              </a-form-item>
            </a-form>
          </fish-card>
        </a-col>

        <a-col :xs="0" :sm="4" :md="5" :lg="6"></a-col>
      </a-row>

      <br />

      <fish-card v-if="oCustomer" fluid color="orange">
        <div slot="header">THÔNG TIN KHÁCH HÀNG</div>

        <a-row type="flex" :gutter="8">
          <a-col :xs="24" :sm="8">
            <fish-card>
              <div slot="header">
                <strong> TỔNG LƯỢT NHẬP </strong>
              </div>

              <div class="guest-stat-value">
                {{ FormatNumber(oCustomer.Entry_Count) }}
              </div>
            </fish-card>
          </a-col>

          <a-col :xs="24" :sm="8">
            <fish-card :color="oCustomer.IsBlock ? 'yellow' : ''">
              <div slot="header">
                <strong> TRÚNG HÔM NAY </strong>
              </div>

              <div>
                <a-tag v-if="oCustomer.IsBlock" color="orange">
                  TẠM KHÓA
                </a-tag>
              </div>

              <div class="guest-stat-value">
                {{ FormatNumber(oCustomer.Day_Win_Count) }}
              </div>

              <div v-if="oCustomer.IsBlock" class="guest-stat-note">
                {{ FormatDateTime(oCustomer.Block_Date) }}
              </div>
            </fish-card>
          </a-col>

          <a-col :xs="24" :sm="8">
            <fish-card :color="oCustomer.IsBlackList ? 'red' : ''">
              <div slot="header">
                <strong> TỔNG TRÚNG </strong>
              </div>

              <div>
                <a-tag v-if="oCustomer.IsBlackList" color="red">
                  BLACKLIST
                </a-tag>
              </div>

              <div class="guest-stat-value">
                {{ FormatNumber(oCustomer.Win_Count) }}
              </div>

              <div v-if="oCustomer.IsBlackList" class="guest-stat-note">
                {{ FormatDateTime(oCustomer.BlackList_Date) }}
              </div>
            </fish-card>
          </a-col>
        </a-row>

        <!-- <a-divider /> -->

        <!-- <a-descriptions size="small" bordered :column="{ xs: 1, sm: 2, md: 3 }">
          <a-descriptions-item label="SĐT">
            {{ oCustomer.User_ID || "---" }}
          </a-descriptions-item>

          <a-descriptions-item label="Họ tên">
            {{ oCustomer.Full_Name || "---" }}
          </a-descriptions-item>

          <a-descriptions-item label="Ngày sinh">
            {{ FormatDate(oCustomer.DoB) }}
          </a-descriptions-item>

        </a-descriptions> -->
      </fish-card>

      <br v-if="oCustomer" />

      <fish-card v-if="oCustomer" fluid>
        <div slot="header">LỊCH SỬ ENTRY</div>

        <a-table
          rowKey="Request_ID"
          size="small"
          :columns="columns"
          :data-source="TBLdata"
          :pagination="false"
        >
          <template slot="Created_At" slot-scope="text">
            {{ FormatDateTime(text) }}
          </template>

          <template slot="Scratch_Status" slot-scope="text">
            <a-tag :color="GetScratchState(text).Color">
              {{ GetScratchState(text).Message }}
            </a-tag>
          </template>

          <template slot="Status" slot-scope="text">
            <a-tag :color="GetEntryState(text).Color">
              {{ GetEntryState(text).Message }}
            </a-tag>
          </template>

          <template slot="Topup_Amount" slot-scope="text">
            {{ FormatNumber(text) }}
          </template>

          <template slot="IsCashout" slot-scope="text">
            <a-tag :color="text ? 'green' : 'blue'">
              <a-icon :type="text ? 'dollar' : 'gift'" />
              {{ text ? "TIỀN MẶT" : "VOUCHER" }}
            </a-tag>
          </template>
        </a-table>

        <a-empty
          v-if="!TBLdata.length"
          description="Khách hàng chưa có Entry"
        />
      </fish-card>
    </fish-segment>
  </div>
</template>

<script>
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

// import Navbar from "@/components/Navbar.vue";

const moment = require("moment");

export default {
  name: "CheckPhone",

  components: {
    // Navbar,
  },

  mounted() {
    this.$nextTick(() => {
      this.form.validateFields();
    });
  },

  data() {
    return {
      isLoading: false,

      hasErrors,

      oCustomer: null,

      form: this.$form.createForm(this, {
        name: "guest_check_phone",
      }),

      TBLdata: [],

      columns: [
        {
          title: "#",
          dataIndex: "Index",
          key: "Index",
          width: "50px",
        },
        {
          title: "CODE",
          dataIndex: "Scratch_Code",
          key: "Scratch_Code",
        },
        {
          title: "NGÀY NHẬP",
          dataIndex: "Created_At",
          key: "Created_At",
          scopedSlots: {
            customRender: "Created_At",
          },
        },
        {
          title: "KẾT QUẢ MÃ",
          dataIndex: "Scratch_Status",
          key: "Scratch_Status",
          scopedSlots: {
            customRender: "Scratch_Status",
          },
        },
        {
          title: "GIÁ TRỊ",
          dataIndex: "Topup_Amount",
          key: "Topup_Amount",
          scopedSlots: {
            customRender: "Topup_Amount",
          },
        },
      ],
    };
  },

  computed: {
    oUser() {
      return this.$store.state.oUser || {};
    },
  },

  methods: {
    PhoneError() {
      const { getFieldError, isFieldTouched } = this.form;

      return isFieldTouched("Phone") && getFieldError("Phone");
    },

    GetAPIData(Response) {
      return Response && Response.data ? Response.data : Response;
    },

    FormatDate(Value) {
      if (!Value) {
        return "---";
      }

      const DateValue = moment(Value);

      if (!DateValue.isValid()) {
        return "---";
      }

      return DateValue.format("DD/MM/YYYY");
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "---";
      }

      const DateValue = moment(Value);

      if (!DateValue.isValid()) {
        return "---";
      }

      return DateValue.format("DD/MM/YYYY HH:mm:ss");
    },

    FormatNumber(Value) {
      return Number(Value || 0).toLocaleString("vi-VN");
    },

    GetScratchState(Value) {
      const Status = String(Value || "").toUpperCase();

      const Map = {
        SUCCESS: {
          Color: "green",
          Message: "Trúng thưởng",
        },

        WRONG: {
          Color: "orange",
          Message: "Không chính xác",
        },

        DUPLICATE: {
          Color: "blue",
          Message: "Đã sử dụng",
        },

        ENDTIME: {
          Color: "gold",
          Message: "Chương trình kết thúc",
        },

        NOTYET: {
          Color: "cyan",
          Message: "Chưa bắt đầu",
        },

        BLOCK: {
          Color: "orange",
          Message: "Tạm khóa",
        },

        BLACKLIST: {
          Color: "red",
          Message: "Blacklist",
        },
      };

      return (
        Map[Status] || {
          Color: "default",
          Message: Value || "---",
        }
      );
    },

    GetEntryState(Value) {
      const Status = String(Value || "").toUpperCase();

      const Map = {
        IN_REVIEW: {
          Color: "orange",
          Message: "Chờ kiểm duyệt",
        },

        RE_REVIEW: {
          Color: "gold",
          Message: "Kiểm duyệt lại",
        },

        PENDING: {
          Color: "cyan",
          Message: "Chờ Supervisor",
        },

        APPROVED: {
          Color: "blue",
          Message: "Đã duyệt",
        },

        GET_VOUCHER: {
          Color: "processing",
          Message: "Đang lấy voucher",
        },

        VOUCHER_ISSUED: {
          Color: "red",
          Message: "Lấy voucher lỗi",
        },

        SENT_VOUCHER: {
          Color: "blue",
          Message: "Đã lấy voucher",
        },

        SENT_ISSUED: {
          Color: "red",
          Message: "Gửi voucher lỗi",
        },

        COMPLETED: {
          Color: "green",
          Message: "Hoàn thành",
        },

        REJECTED: {
          Color: "red",
          Message: "Từ chối",
        },
      };

      return (
        Map[Status] || {
          Color: "default",
          Message: Value || "---",
        }
      );
    },

    async handleSubmit(Event) {
      Event.preventDefault();

      this.form.validateFields(async (Error, Values) => {
        if (Error) {
          return;
        }

        this.oCustomer = null;

        this.TBLdata = [];

        try {
          this.isLoading = true;

          const Response = await this.$PostAPI("/check-phone", {
            Token: this.oUser.Token,
            Phone: Values.Phone,
          });

          const Result = this.GetAPIData(Response);

          if (!Result || Result.State !== 1) {
            this.$message.error(
              Result && Result.Message
                ? Result.Message
                : "Không kiểm tra được khách hàng.",
              3000,
            );

            return;
          }

          const Data = Result.Data || {};

          this.oCustomer = Data.Customer || null;

          this.TBLdata = (Data.Entries || []).map((Entry, Index) => {
            return Object.assign(
              {
                Index: Index + 1,
              },
              Entry,
            );
          });
        } catch (Error) {
          console.log("Guest-CheckPhone-Error:", Error);

          this.$message.error(
            "Có lỗi xảy ra trong quá trình kiểm tra khách hàng.",
            3000,
          );
        } finally {
          this.isLoading = false;
        }
      });
    },
  },
};
</script>

<style>
.guest-stat-value {
  padding: 8px 0;
  color: #111;
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
}

.guest-stat-note {
  color: #cf1322;
  font-size: 11px;
  text-align: center;
}
</style>
